/**
 * Store state for wordpress/account module
 */
export const initialState = {
  url: localStorage.getItem('url') || '',
  username: localStorage.getItem('username') || '',
  password: localStorage.getItem('password') || '',
  token: localStorage.getItem('token') || '',
  id: localStorage.getItem('id') || '',
  email: localStorage.getItem('email') || '',
  avatar_url: localStorage.getItem('avatar_url') || ''
}

const state = {...initialState}

export default state



// WEBPACK FOOTER //
// ./src/store/modules/wordpress/account/state.js